// OtherFeatures.js
import React from 'react';
import { Row } from 'react-bootstrap';
import { OthersInSet } from './OthersInSet';

export const OtherFeatures = () => (
  <Row xs={4} className="feature-thumbnail-row">
    <OthersInSet />
  </Row>
);



// WEBPACK FOOTER //
// ./src/comps/Feature/OtherFeatures.js